import { Link } from 'react-router-dom';
import type { NavItem } from './nav';

/**
 * The destinations in the desktop rail, drawn as the handoff draws them (D12, L-12, S-25): no
 * icons, 44px rows, an indicator bar on the left, the current destination on the accent tint at
 * weight 500 and the rest in ink at 400. The current row is the destination the route belongs to,
 * so Learn stays marked on an item and Record on the certificate, renewal and account.
 */
export function Rail({
  items,
  activePath,
  className = '',
}: {
  items: NavItem[];
  activePath?: string | undefined;
  className?: string;
}) {
  return (
    <nav aria-label="Primary" className={className}>
      <ul className="flex flex-col gap-0.5">
        {items.map((item) => {
          const current = item.to === activePath;
          return (
            <li key={item.to}>
              <Link
                to={item.to}
                aria-current={current ? 'page' : undefined}
                className={`flex h-11 items-center gap-3 rounded-[10px] px-3 text-[14px] text-ink no-underline transition-colors duration-150 ease-ea ${
                  current ? 'bg-accentTint font-medium' : 'font-normal hover:bg-chip'
                }`}
              >
                <span
                  aria-hidden="true"
                  className={`h-3.5 w-[3px] shrink-0 rounded-full ${current ? 'bg-accent' : 'bg-rule'}`}
                />
                <span>{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
